import { createFileRoute } from "@tanstack/react-router";
import { ProposalPublicPage } from "@/features/proposalpublic/ProposalPublicPage";

/** Public proposal page for one proposal. Sits outside the _app layout, so there is no app shell. */
export const Route = createFileRoute("/p/proposal/$token")({
  component: ProposalRoute,
});

function ProposalRoute() {
  const { token } = Route.useParams();
  return <ProposalPublicPage token={token} />;
}
